import { Button } from "@/components/catalyst/button";
import { BanknotesIcon } from "@heroicons/react/24/outline";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { IssueContactCreditDialog } from "@/app/ContactCredits/Components/IssueContactCreditDialog";
import { useTenant } from "@/app/Organisations/Hooks/useTenant";

export function IssueContactCreditButton({ contactId }: { contactId: string }) {
  const { open } = useDialog(IssueContactCreditDialog);
  const { isAdmin } = useTenant();

  if (!isAdmin) {
    return null;
  }

  return (
    <Button onClick={() => open({ contactId })}>
      <BanknotesIcon />
      Issue credit
    </Button>
  );
}
